import styled from 'styled-components';

/* Jedna kolumna z wyśrodkowanym formularzem. Wcześniej ekran dzielił się na animowaną
   kratkę po lewej i formularz po prawej; kratka nic nie wnosiła, a gradient pod nią
   wymuszał ciemne tło na całej szerokości. */
export const MainContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    width: 100%;
    background: #faf8f3;
`;

export const FormContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 2rem;
`;

export const LoginBox = styled.div`
    width: 100%;
    max-width: 440px;
    padding: 3rem 2rem;
    animation: fadeInUp 0.6s ease-out;

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(30px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: 768px) {
        padding: 2rem 1.5rem;
    }
`;

export const LoginHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 3rem;

    img {
        height: 56px;
        filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
        transition: transform 0.3s ease;

        &:hover {
            transform: scale(1.05);
        }
    }

    @media (max-width: 768px) {
        margin-bottom: 2rem;

        img {
            height: 48px;
        }
    }
`;

export const AppName = styled.h1`
    font-size: 1.875rem;
    font-weight: 700;
    color: #1a4d6d;
    letter-spacing: -0.025em;
    text-align: center;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 1.5rem;
    }
`;

export const LoginContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
`;

export const WelcomeText = styled.div`
    text-align: center;
    margin-bottom: 1rem;

    h2 {
        font-size: 1.25rem;
        font-weight: 600;
        color: #1a4d6d;
        margin: 0 0 0.5rem 0;
    }

    p {
        font-size: 0.875rem;
        color: #5a7a8f;
        margin: 0;
    }
`;

export const GoogleButton = styled.button<{ $isLoading?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    width: 100%;
    padding: 0.875rem 1.5rem;
    font-size: 1rem;
    font-weight: 500;
    color: white;
    background: linear-gradient(135deg, #1a4d6d 0%, #2c5f7d 100%);
    border: none;
    border-radius: 12px;
    cursor: ${(props) => (props.$isLoading ? 'not-allowed' : 'pointer')};
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(26, 77, 109, 0.3);
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(197, 165, 114, 0.3), transparent);
        transition: left 0.5s ease;
    }

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(26, 77, 109, 0.4);
        background: linear-gradient(135deg, #1a4d6d 0%, #2c5f7d 50%, #c5a572 100%);

        &::before {
            left: 100%;
        }
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:disabled {
        opacity: 0.7;
    }

    svg {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
    }
`;

export const InfoText = styled.p`
    font-size: 0.875rem;
    color: #5a7a8f;
    text-align: center;
    margin: 0;
    padding: 0 1rem;
    line-height: 1.5;
`;

export const Divider = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    margin: 1.5rem 0;

    &::before,
    &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: #d4c5ab;
    }

    span {
        font-size: 0.875rem;
        color: #5a7a8f;
        font-weight: 500;
    }
`;

export const LoadingSpinner = styled.div`
    width: 20px;
    height: 20px;
    border: 2.5px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;
